import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";

import { MEMBER, PAGE } from "./memberIdentifierRecoveryModels";

import * as intlActions from "../intl/intlActions";
import * as memberIdentifierRecoveryActions from "./memberIdentifierRecoveryActions";

import { PublicPage } from "../common";
import MemberIdentifierRecoveryForm from "./MemberIdentifierRecoveryForm";

class MemberIdentifierRecoveryPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.recover = this.recover.bind(this);
  }

  componentDidMount() {
    const {
      clientDesignator,
      intlActions,
      languageCode,
      memberIdentifierRecoveryActions,
    } = this.props;

    if (!document.getElementById("reCaptchaV2")) {
      const script = document.createElement("script");
      script.id = "reCaptchaV2";
      script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${languageCode}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        intlActions.setLocale(languageCode);
        setTimeout(
          () =>
            memberIdentifierRecoveryActions.request(
              PAGE,
              { designator: clientDesignator.toUpperCase() },
              { "Accept-Language": languageCode }
            ),
          1000
        );
      };
      document.body.appendChild(script);
    }
  }

  recover(values) {
    const {
      client,
      languageCode,
      memberIdentifierRecoveryActions,
    } = this.props;
    const {
      birthdate,
      emailAddress,
      firstName,
      gRecaptchaResponse,
      lastName,
      phoneNumber,
      postalCode,
    } = values;
    const body = {
      birthdate,
      firstName,
      gRecaptchaResponse,
      lastName,
      phoneNumber,
      postalCode: postalCode.replace(" ", ""),
      clientId: client,
      destinationEmail: emailAddress,
    };

    return memberIdentifierRecoveryActions.recoverIdentifier(MEMBER, body, {
      "Accept-Language": languageCode,
    });
  }

  render() {
    const {
      clientDesignator,
      formIntro,
      languageCode,
      loaded,
      mustUseInstitutionEmailForRecovery,
      pageExists,
    } = this.props;

    if (!loaded) return null;

    let languageSwitchSlug;
    let languageSwitchLabel;

    switch (languageCode) {
      case "en-CA": {
        languageSwitchSlug = "recuperation-codemajor";
        languageSwitchLabel = "FR";
        break;
      }
      case "fr-CA": {
        languageSwitchSlug = "majorcode-recovery";
        languageSwitchLabel = "EN";
        break;
      }
      default: {
        languageSwitchSlug = "";
        languageSwitchLabel = "";
      }
    }

    const languageSwitch = (
      <a href={`/${languageSwitchSlug}/${clientDesignator}`}>
        {languageSwitchLabel}
      </a>
    );

    return (
      <PublicPage
        cssClass="member-identifier-recovery-page"
        clientDesignator={clientDesignator}
        languageSwitch={languageSwitch}
        pageExists={pageExists}
      >
        <h2>
          <FormattedMessage id="memberIdentifierRecovery.body.title" />
        </h2>
        <p className="pre-wrap">{formIntro}</p>
        <h3>
          <FormattedMessage id="memberIdentifierRecovery.form.title" />
        </h3>
        <MemberIdentifierRecoveryForm
          mustUseInstitutionEmailForRecovery={
            mustUseInstitutionEmailForRecovery
          }
          onSubmit={this.recover}
        />
      </PublicPage>
    );
  }
}

MemberIdentifierRecoveryPage.propTypes = {
  client: PropTypes.number,
  clientDesignator: PropTypes.string,
  formIntro: PropTypes.string,
  intlActions: PropTypes.object,
  languageCode: PropTypes.string,
  loaded: PropTypes.bool,
  memberIdentifierRecoveryActions: PropTypes.object,
  mustUseInstitutionEmailForRecovery: PropTypes.bool,
  pageExists: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const page = state.memberIdentifierRecovery.page || {};
  const languageCode = ownProps.params.languageCode;

  const {
    clientId,
    hasMemberIdentifierRecoveryForm,
    localizations,
    mustUseInstitutionEmailForRecovery,
  } = page;

  return {
    languageCode,
    mustUseInstitutionEmailForRecovery,
    client: clientId,
    clientDesignator: ownProps.params.clientDesignator,
    formIntro:
      (localizations &&
        localizations[languageCode].recoveryMemberIdentifierFormMessage) ||
      "",
    loaded: page.loaded,
    pageExists: hasMemberIdentifierRecoveryForm,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    intlActions: bindActionCreators(intlActions, dispatch),
    memberIdentifierRecoveryActions: bindActionCreators(
      memberIdentifierRecoveryActions,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberIdentifierRecoveryPage);



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/MemberIdentifierRecoveryPage.js